type SwitchProps = {
  checked: boolean;
  label: string;
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
};

export function Switch({
  checked,
  label,
  disabled = false,
  onCheckedChange,
}: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={[
        "relative inline-flex h-5 w-9 shrink-0 items-center rounded-full p-0.5 transition-colors duration-200 ease-in-out",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2F7BFF]/20",
        checked ? "bg-[#2F7BFF]" : "bg-[#E2E8F0]",
        disabled
          ? "cursor-not-allowed opacity-60"
          : checked
            ? "cursor-pointer hover:bg-[#256DE5]"
            : "cursor-pointer hover:bg-[#D8E0EB]",
      ].join(" ")}
    >
      <span
        className={[
          "pointer-events-none inline-block h-4 w-4 rounded-full bg-white",
          "shadow-[0_1px_2px_rgba(15,23,42,0.22)] transition-transform duration-200 ease-in-out",
          checked ? "translate-x-4" : "translate-x-0",
        ].join(" ")}
      />
    </button>
  );
}
